import { defineComponent as _defineComponent } from 'vue'
import { getBlankTableList } from '@/apis/baseMaterial/blankTable'
import { buryPoint } from '@/apis/common/buryPoint'
import { fetchGetProductionNcSetting } from '@/apis/materialList'
import { getProductionLineSetting } from '@/apis/paibanHistory'
import { comparePreLayoutSetting } from '@/apis/preLayoutSetting'
import store from '@/store'
import {
  getCutKnifeDiameterList,
  getSawKnife,
  isSawPaiban,
} from '@/util/LayoutFuncs'
import { translate } from '@/util/commonFun'
import { dealPreLayoutSettingFromNCSetting } from '@/views/materialsList/util/preLayoutDeal'
import { computed, onMounted, ref, watch } from 'vue'

import MConflictTable from './m-conflict-table.vue'

interface PropsType {
  visible: boolean
  proLineId?: number
  isExpandedArranged?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'm-line-select-modal',
  props: {
    visible: { type: Boolean },
    proLineId: null,
    isExpandedArranged: { type: Boolean }
  },
  emits: [
  'onCancel',
  'onConfirm',
  'onClose',
  'onVisibleChange',
],
  setup(__props: any, { emit: emits }) {

const props = __props as {
  visible: boolean
  proLineId?: number
  isExpandedArranged?: boolean
}



const lineId = ref<number>()
const lineList = ref<{ label: string; value: number }[]>([])
const isVisible = ref(props.visible)
/** 生产线设置对比冲突 */
const confilict = ref(null)
const confilictTotal = ref(0)
/** 是否是查看详情状态 */
const isDetail = ref(false)
const isLoadingSetting = ref(false)
/** 有否存在长板二次切割冲突 */
const hasLongCuttingChanged = ref(false)
/** 是否刀具冲突 */
const isKnifeConfilict = ref(false)
/** 是否存在拉直器扩刀冲突等特殊问题 */
const hasSpecialConfilict = ref(false)
/** 是否特殊孔槽分流设置问题 */
const isShuntSettingConfilict = ref(false)
/** 是否存在门套切割 下料刀半径（不能）>锯片厚度 */
const isDoorFrameKnifeGT = ref(false)
/** 接口返回的错误提示 */
const errorMsg = ref('')
/** 目标生产线是否勾选单独海棠角文件 */
const isTargetLineHasShuntSetting = ref(true)



/** 表示是否需要重新排版 */
const isNeedReLayout = computed(() => {
  return (
    lineId.value &&
    lineId.value !== store.state.ncSetting.process_setting_id && // 有生产线，并且选择与现有生产线不同的生产线
    (confilict.value || isKnifeConfilict.value) // 设置冲突或者有不同材质下料刀冲突都会提示重新排版
  )
})

const isExpandedRelayout = computed(() => {
  return (
    lineId.value &&
    lineId.value !== store.state.ncSetting.process_setting_id && // 有生产线，并且选择与现有生产线不同的生产线
    (props.isExpandedArranged
      ? props.isExpandedArranged
      : !isTargetLineHasShuntSetting.value)
  ) // 存在特殊工艺冲突
})

const isShowKnifeConfilict = computed(() => {
  return (
    lineId.value &&
    lineId.value !== store.state.ncSetting.process_setting_id && // 前两个条件表示有生产线但是选择的是不相同的生产线
    isKnifeConfilict.value && //有不同材质下料刀冲突
    !confilict.value && // 并且没有生产线排版参数设置冲突
    !isLoadingSetting.value
  ) // 并且没有正在加载生产线设置
})

/** 获取参与排版的板件列表 */
function getLayoutPartList() {
  return store.state.paibanData.map((item: any) => item.parts).flat()
}

/** 校验目标生产线门套切割：下料刀半径是否大于锯片厚度（含多材质下料刀） */
function checkTargetLineDoorFrameKnifeGT(targetNcSetting: any) {
  const isDoorFrame =
    targetNcSetting.sawSetting?.mentaoji_enable &&
    targetNcSetting.sawSetting?.processType === 'doorFrame' &&
    isSawPaiban(store)
  if (!isDoorFrame) return false

  const sawKnife = getSawKnife(targetNcSetting)
  const knifeDiameters = getCutKnifeDiameterList(
    targetNcSetting,
    getLayoutPartList()
  )
  return knifeDiameters.some((diameter) => diameter / 2 > sawKnife)
}

const handleChange = async (value: number) => {
  isLoadingSetting.value = true
  errorMsg.value = ''
  isDoorFrameKnifeGT.value = false
  const currentLayoutSetting = dealPreLayoutSettingFromNCSetting(
    store.state.ncSetting
  )

  const [res, targetNcRes] = await Promise.all([
    comparePreLayoutSetting({
      setting_value: currentLayoutSetting,
      process_setting_id: value,
    }),
    fetchGetProductionNcSetting({ setting_id: value }),
  ])

  if (targetNcRes.status === 1) {
    isDoorFrameKnifeGT.value = checkTargetLineDoorFrameKnifeGT(targetNcRes.data)
    if (isDoorFrameKnifeGT.value) {
      errorMsg.value = translateLang(
        '不能切换生产线，目标生产线开启了"锯切雕刻机-门套切割"功能，下料刀半径大于了锯片厚度，无法进行排版！'
      )
    }
  }

  const curretnEnableSingleFile =
    store.state.ncSetting.singleFileSetting?.enable
  const tartgetEnableSingleFile = targetNcRes.data.singleFileSetting?.enable
  isLoadingSetting.value = false
  const singleFileHandleSlope =
    (!tartgetEnableSingleFile && !curretnEnableSingleFile) ||
    (tartgetEnableSingleFile &&
      curretnEnableSingleFile &&
      targetNcRes.data.singleFileSetting?.processTypes.includes(
        'handleSlope'
      ) &&
      store.state.ncSetting.singleFileSetting?.processTypes.includes(
        'handleSlope'
      ))
  if (res.status > 0) {
    isShuntSettingConfilict.value = false
    hasSpecialConfilict.value =
      checkSpecialSlotExpanded() &&
      Boolean(lineId.value) &&
      lineId.value !== store.state.ncSetting.process_setting_id
    confilict.value = res.data.total ? res.data.data : null
    confilictTotal.value = res.data.total
    const longCutSetting = res.data?.data?.longPlankCuttingSetting
    hasLongCuttingChanged.value =
      longCutSetting &&
      ((longCutSetting.longPlankCuttingEnable && // 改动为启用长板加工
        longCutSetting.longPlankCuttingEnable[1]) ||
        longCutSetting.longPlankShortExpandedSize || // 或者短边放量、长边放量有改动
        longCutSetting.longPlankExpandedSize)
    isTargetLineHasShuntSetting.value = singleFileHandleSlope
  } else {
    if (!isDoorFrameKnifeGT.value) {
      errorMsg.value = res.msg
    }
    confilict.value = null
    confilictTotal.value = 0
    hasLongCuttingChanged.value = false
    isShuntSettingConfilict.value = false
    // 等于 0 是目标生产线勾选孔槽分流特殊孔槽优先正面
    if (!res.status) {
      isShuntSettingConfilict.value = true
    }
    // 目标生产线没有勾选单独生成海棠角和斜封边拉手文件
    if (res.status == -1) {
      isTargetLineHasShuntSetting.value = false
    } else {
      isTargetLineHasShuntSetting.value = singleFileHandleSlope
    }
  }
}

/** 检查是否有圆弧铣底 */
const checkSpecialSlotExpanded = () => {
  const allParts = store.state.paibanData.map((item: any) => item.parts).flat()
  return allParts.some((item: any) => {
    const slots = item.slots as any[]
    const isNeedExpande = slots.some((slot: any) => {
      return [
        'arcMilledSlot',
        'arcStraightSlot',
        'arcTopMilledSlot',
        'arcBottomMilledSlot',
      ].includes(slot['symbol'])
    })
    return isNeedExpande
  })
}

/** 判断参与排版的板件中是否有指定下料刀 */
const dealMaterialKnife = (resData: any) => {
  const matCodeList = resData.data.map(
    (item: any) => `${item.matCode}:${item.thick}`
  )

  const paibanMatCodeList = store.state.paibanData.map(
    (item: any) => `${item.matCode}:${item.thick}`
  )

  return paibanMatCodeList.some((item: any) => matCodeList.includes(item))
}
const handleConfirm = () => {
  isVisible.value = false
  emits(
    'onConfirm',
    lineId.value,
    isNeedReLayout.value || isExpandedRelayout.value
  )
}

const handleCancel = () => {
  isVisible.value = false
  emits('onCancel', false)
}
const handleClose = () => {
  isDetail.value = false
  emits('onClose', false)
}

const handleCheckDetail = () => {
  buryPoint({
    function_module: 'preLayoutSetting',
    function_point: 'checkDetail',
  })
  isDetail.value = true
}

const hanldeBackToSelect = () => {
  isDetail.value = false
}

const initialData = async () => {
  isLoadingSetting.value = true
  const res = await getProductionLineSetting(1)
  if (res.status) {
    lineList.value = res.data.map((item: any) => {
      return {
        label: item.name,
        value: item.id,
      }
    })
    if (lineId.value) {
      const currentLayoutSetting = dealPreLayoutSettingFromNCSetting(
        store.state.ncSetting
      )
      const [compareRes, targetNcRes] = await Promise.all([
        comparePreLayoutSetting({
          setting_value: currentLayoutSetting,
          process_setting_id: lineId.value,
        }),
        fetchGetProductionNcSetting({ setting_id: lineId.value }),
      ])
      isLoadingSetting.value = false
      isDoorFrameKnifeGT.value = false
      if (targetNcRes.status === 1) {
        isDoorFrameKnifeGT.value = checkTargetLineDoorFrameKnifeGT(
          targetNcRes.data
        )
        if (isDoorFrameKnifeGT.value) {
          errorMsg.value = translateLang(
            '不能切换生产线，目标生产线开启了"锯切雕刻机-门套切割"功能，下料刀半径大于了锯片厚度，无法进行排版！'
          )
        }
      }

      if (compareRes.status > 0) {
        confilict.value = compareRes.data.total ? compareRes.data.data : null
        confilictTotal.value = compareRes.data.total
      } else if (!isDoorFrameKnifeGT.value) {
        errorMsg.value = compareRes.msg
      }
    }
    const materialKnifeRes = await getBlankTableList()
    const hasPlankKnife = dealMaterialKnife(materialKnifeRes.data)
    if (hasPlankKnife) {
      isKnifeConfilict.value = true
    }
    isLoadingSetting.value = false
  }
}

const translateLang = (key: string, values?: any) => {
  return translate(key, values)
}

onMounted(async () => {
  if (store.state.ncSetting.isPreLayout && !lineId.value) {
    initialData()
  }
})

watch(
  () => isVisible.value,
  async (val) => {
    if (isVisible.value) {
      buryPoint({
        function_module: 'layout',
        function_point: 'layout_select_modal',
      })
      initialData()
    }
    emits('onVisibleChange', val)
  }
)

watch(
  () => props.visible,
  (val) => {
    isVisible.value = val
  }
)

return { __sfc: true,props, lineId, lineList, isVisible, confilict, confilictTotal, isDetail, isLoadingSetting, hasLongCuttingChanged, isKnifeConfilict, hasSpecialConfilict, isShuntSettingConfilict, isDoorFrameKnifeGT, errorMsg, isTargetLineHasShuntSetting, emits, isNeedReLayout, isExpandedRelayout, isShowKnifeConfilict, getLayoutPartList, checkTargetLineDoorFrameKnifeGT, handleChange, checkSpecialSlotExpanded, dealMaterialKnife, handleConfirm, handleCancel, handleClose, handleCheckDetail, hanldeBackToSelect, initialData, translateLang, store, MConflictTable }
}

})